import { useRefetchMerchantOnStageChange } from '@/components/loan-process/hooks/use-refetch-merchant-on-stage-change';

import { AgreementSuccessful } from './agreement-successful/agreement-successful';

export function StageFive() {
  useRefetchMerchantOnStageChange();

  return <AgreementSuccessful />;
}
